import { CellProps, Row } from 'src/components/DataTable/types';

function ExpectedVersionCell({ value }: CellProps<any, Row>) {
  let versions: string[] = [];
  if (Array.isArray(value)) {
    versions = value;
  } else if (value) {
    versions = [value];
  }

  if (versions.length === 0) {
    return <span style={{ color: '#ED6C02', fontWeight: 500 }}>-</span>;
  }
  return <span>{versions.join(', ')}</span>;
}

export default ExpectedVersionCell;
